export default "__VITE_ASSET__d55d8591__"